import React from 'react';
import { Chip } from '@mui/material';
import { getLevelColours, ScoreLevelName } from '../../interfaces/INetworkScore';

interface LevelTagProps {
    level: ScoreLevelName;
    /** Badge colour key for this level, when known — see {@link getLevelColours}. Falls back to a neutral grey when absent. */
    badgeColourKey?: string | null;
    size?: 'small' | 'medium';
}

/**
 * The tinted "level tag" pill (network-score.md, section 6) — used next to a name anywhere the
 * avatar is under 48px: connection cards, invitations, search results, post author lines. Colour
 * comes solely from `badgeColourKey`, so an admin renaming or re-colouring a level needs no
 * frontend change.
 */
export const LevelTag: React.FC<LevelTagProps> = ({ level, badgeColourKey, size = 'small' }) => {
    const colours = getLevelColours(badgeColourKey);

    return (
        <Chip
            label={level.toUpperCase()}
            size={size}
            sx={{
                bgcolor: colours.tagBg,
                color: colours.tagText,
                fontWeight: 700,
                letterSpacing: '0.02em',
                height: size === 'small' ? 22 : 26,
            }}
        />
    );
};

export default LevelTag;
